import React from 'react';
import cn from 'classnames';

import { ButtonStatus } from '../index';

import styles from './styles.module.scss';
import {
    BackIcon,
    ChangeIcon,
    MinusIcon,
    PlusIcon,
} from '../Icon';

export enum ButtonType {
    Back,
    Plus,
    Minus,
    Change,
}

interface Props extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  status?: ButtonStatus;
  type: ButtonType;
  onClick?(): void;
}

const IconButton: React.FC<Props> = props => {
  const { className, onClick, status = ButtonStatus.Normal, type, ...buttonProps } = props;

  const statusClass = {
    [ButtonStatus.Normal]: null,
    [ButtonStatus.Active]: styles.active,
    [ButtonStatus.Disabled]: styles.disabled,
  }[status];

  const Icon = {
    [ButtonType.Back]: BackIcon,
    [ButtonType.Change]: ChangeIcon,
    [ButtonType.Plus]: PlusIcon,
    [ButtonType.Minus]: MinusIcon,
  }[type];

  return (
        <div
            className={cn(styles.btn, statusClass, className)}
            onClick={onClick}
            {...buttonProps}
        >
            <Icon className={styles.icon} />
        </div>
  );
};

export default IconButton;
